<template>
    <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white" id="sidenav-main">
        <div class="container-fluid">

            <!--Toggler-->
            <navbar-toggle-button @click.native="showSidebar" class="burger-icon">
                <span class="navbar-toggler-icon"></span>
            </navbar-toggle-button>
  
            <slot name="mobile-right">
                <ul class="nav align-items-center d-md-none">
                    <base-dropdown class="nav-item" position="right">
                        <a slot="title" class="nav-link" href="#" role="button">
                            <div class="media align-items-center">
                            <i class="far fa-user-circle header-icon"></i>
                            </div>
                        </a>

                        <!-- <div class="dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Welcome!</h6>
                        </div> -->
                        <div class="dropdown-item d-flex align-items-center py-0">
                            <i class="ni ni-single-02"></i>
                            <div class="d-flex flex-column">
                                <span class="mb-0">{{userLogin.name}}</span>
                                <h5 class="mb-0">{{userLogin.role}}</h5>
                            </div>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div class="col-lg-12">
                          <BaseShopDetails></BaseShopDetails>
                        </div>
                        <div class="dropdown-divider"></div>
                        <router-link to="/logout" class="dropdown-item">
                            <i class="ni ni-user-run"></i>
                            <span>Logout</span>
                        </router-link>
                    </base-dropdown>
                </ul>
            </slot>
            <slot></slot>
            <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">

                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                <img :src="logo">
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
                        </div>
                    </div>
                </div>

                <ul class="navbar-nav pt-4">
                    <slot name="links">
                    </slot>
                     <slot name="links-after">
                    </slot>
                </ul>      
                
            </div>
            </div>
    </nav>
</template>
<script>
  import NavbarToggleButton from '@/components/NavbarToggleButton'
  import BaseShopDetails from "@/components/BaseShopDetails"
  
  export default {
    name: 'sidebar',
    data() {
    return {
      popVersion: process.env.VUE_APP_VERSION,
      userLogin: ""
    };
  },
    mounted(){
      this.userLogin = JSON.parse(localStorage.getItem('user'))
    },
    components: {
      NavbarToggleButton,
      BaseShopDetails
    },
    props: {
      logo: {
        type: String,
        default: 'img/brand/logo.png',
        description: 'Sidebar app logo'
      },
      autoClose: {
        type: Boolean,
        default: true,
        description: 'Whether sidebar should autoclose on mobile when clicking an item'
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      };
    },
    methods: {
      closeSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      showSidebar() {
        this.$sidebar.displaySidebar(true)
      },
    },
    beforeDestroy() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false;
      }
    }
  };
</script>
<style lang="scss" scoped>

  .burger-icon { 
    font-size: 1.5rem;
  }
  .header-icon { 
    font-size: 1.8rem;
  }
</style>